import React from "react";
import Button from '@material-ui/core/Button';
import withStyles from "@material-ui/core/styles/withStyles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import HistoryIcon from '@material-ui/icons/History';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import { fade } from '@material-ui/core/styles/colorManipulator';
import moment from 'moment'

import api from "../../api/backend"

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

const styles = theme => ({
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class History extends React.Component {
    state = {
        open: false, histories: []
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    getHistory = () => {
        const { user } = this.props;
        api.getHistoryByUser(user.userName).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ histories: json })
            }
        }).catch(() => { })
    }

    toggleHistory = (id) => {
        api.toggleHistory(id).then(([response, json]) => {
            if (response.status === 200) {
                this.getHistory()
            } else {
                console.error('ไม่สามารถลบการลงทะเบียนได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    componentDidMount() {
        this.getHistory();
    }

    render() {
        const { histories } = this.state;
        return (
            <React.Fragment>
                <IconButton aria-label="View" onClick={this.handleClickOpen} >
                    <HistoryIcon fontSize="small" />
                </IconButton>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle id="form-dialog-title">ประวัติการดู</DialogTitle>
                    <DialogContent>
                        <Paper>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>วีดีโอ</TableCell>
                                        <TableCell >คอร์ส</TableCell>
                                        <TableCell align="right" style={{ width: 150 }}>วันที่ดู</TableCell>
                                        <TableCell align="right" style={{ width: 150 }}>สถานะ</TableCell>
                                        <TableCell align="right" style={{ width: 150 }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {histories.map(history => (
                                        <TableRow key={history.history.id}>
                                            <TableCell component="th" scope="row">
                                                {history.history.video.title}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {history.course.title}
                                            </TableCell>
                                            <TableCell align="right">{moment(history.history.created).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                            <TableCell align="right">{history.history.deactivated ? 'ไม่ใช้งาน' : ' ใช้งาน'}</TableCell>
                                            <TableCell align="right">
                                                <IconButton aria-label="CheckBox" onClick={() => this.toggleHistory(history.history.id)}>
                                                    {history.history.deactivated ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="default" >
                            ปิด
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

History.propTypes = {
};

export default withStyles(styles)(History);